import { api } from '@/api/main.api'

export async function apiGetPaymentClientToken (clientTokenId) {
  return api('post', `/v3/project/stripe-payment/clientToken?id=${clientTokenId}`)
}

export async function apiGetStripePlatformRedirect (clientId) {
  return api('get', `/v3/project/stripe-payment/portal-session?id=${clientId}`)
}

export async function apiCreateStripeCustomer (customerId) {
  return api('post', `/v3/project/stripe-payment/create-or-update-customer?id=${customerId}`)
}

export async function apiCancelSubscription (id) {
  return api('post', `/v3/project/stripe-payment/cancel-subscription?id=${id}`)
}



// WEBPACK FOOTER //
// ./src/api/stripe.api.js